<template>
  <div>
    <Modal :title="title" v-model="modalShow">
      <div class="req-form">
        <Form ref="reqForm" :model="reqForm" style="padding-right: 10px" :rules="reqRule">
          <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
          <FormItem label="卷名称">
            <Input v-model="volumeData.name" :disabled="true" style="width: 300px" />
          </FormItem>
          <FormItem label="状态" prop="status">
            <Select v-model="reqForm.status" transfer placeholder="请选择一个新的状态">
              <Option key="available" value="available" v-if="current_status !== 'available'">可用</Option>
              <Option key="in-use" value="in-use" v-if="current_status !== 'in-use'">正在使用</Option>
              <Option key="error" value="error" v-if="current_status !== 'error'">错误</Option>
              <Option key="creating" value="creating" v-if="current_status !== 'creating'">创建中</Option>
              <Option key="attaching" value="attaching" v-if="current_status !== 'attaching'">连接实例中</Option>
              <Option key="detaching" value="detaching" v-if="current_status !== 'detaching'">从实例分离中</Option>
              <Option key="deleting" value="deleting" v-if="current_status !== 'deleting'">删除中</Option>
              <Option key="error_deleting" value="error_deleting" v-if="!current_status !== 'error_deleting'">删除时出错</Option>
              <Option key="maintenance" value="maintenance" v-if="current_status !== 'maintenance'">维护</Option>
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="modalShow = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { actionPrivateCloudVolume, detailPrivateCloudVolume } from '@/api/private-cloud/volume'
export default {
  name: 'volume-update-status',
  data () {
    return {
      title: '更新卷状态',
      volumeData: {},
      modalShow: false,
      submitting: false,
      reqForm: {
        status: ''
      },
      reqRule: {
        status: [
          { required: true, message: '请选择一个新的状态', trigger: 'change' }
        ]
      },
      current_status: '',
      errorMsg: '',
      errorMsgShow: false
    }
  },
  methods: {
    openModal (id, status) {
      this.current_status = status
      detailPrivateCloudVolume(id).then(res => {
        this.volumeData = res.data.volume
        this.modalShow = true
      })
    },
    submit () {
      this.$refs['reqForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            'os-reset_status': this.reqForm
          }
          this.submitting = true
          actionPrivateCloudVolume(reqData, this.volumeData.id).then(res => {
            this.modalShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.submitting = false
            this.$emit('callback')
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .req-form {
    max-height: 650px;
    overflow-y: auto;
  }
  .req-form::-webkit-scrollbar {
    width: 5px;
  }
  .req-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .req-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
